<template>
  <div>
    <v-app-bar color="rgb(219,241,241)">
      <v-toolbar-title @click="toHome()" class="d-flex">
        <!-- <v-img
          v-if="companyList.system && companyList.system.LOGO"
          :src="`data:image/jpg;base64,${companyList.system.LOGO}`" 
          class="ml-3 mt-0 py-0"
          -->
        <v-img
          v-if="logoPath"
          :src="require('@/assets/logo_empresa.png')"
          contain
          height="80"
        />
        <v-img
          v-else
          :src="require('@/assets/megabit-160.png')"
          width="65"
          class="ml-3"
        />
      </v-toolbar-title>

      <div v-if="this.$store.state.viewContext !== 'companyList'">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              class="red darken-4 ml-5 white--text"
              outlined
              @click.stop="openCepDialog()"
            >
              <v-icon left>mdi-map-marker</v-icon>
              <small class="pa-2"
                >{{
                  region && region.endereco.value.length > 10
                    ? region.endereco.value.substring(0, 10) + '...'
                    : 'Informe seu CEP'
                }}
              </small>
            </v-btn>
          </template>
          <span>{{ tooltipCepText }}</span>
        </v-tooltip>
        <v-dialog
          v-if="form"
          v-model="showFormCEP"
          max-width="250px"
          transition="dialog-top-transition"
          content-class="my-custom-dialog"
        >
          <v-card>
            <v-card-title>
              <h3 class="pa-2 font-weight-bold">Digite seu cep</h3>
            </v-card-title>
            <v-card-text>
              <c-input-cep
                v-model="cmpRegion.cep.value"
                :label="cmpRegion.cep.label"
                :maxLength="8"
                @keyUp="consultaCep($event)"
                :appendIcon="alertCepIcon"
                class="mt-2 headline"
              >
              </c-input-cep>

              <div v-if="cmpRegion.endereco.value" class="d-flex flex-column">
                <div v-for="(data, index) in form" :key="index">
                  <h5 v-if="data.value">
                    <strong>{{ data.label }}:</strong> {{ data.value }}
                  </h5>
                </div>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-btn
                :loading="loadingButton"
                class="info"
                @click.prevent="consultaValorFrete()"
              >
                OK
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
      <v-spacer></v-spacer>

      <!-- mobile menu button -->
      <span class="hidden-sm-and-up">
        <!-- <v-btn @click.stop="drawer = !drawer"> Menu </v-btn> -->
        <v-icon size="40" @click.stop="drawer = !drawer">mdi-menu</v-icon>
      </span>

      <!-- desktop & tablet menu -->
      <v-toolbar-items class="hidden-xs-only">
        <div v-if="1 == 2">
          <v-divider vertical></v-divider>
          <v-icon @click="openAccount">mdi-account-outline</v-icon>
          <v-btn icon dark class="">
            <v-icon x-small color="#878A94">fa-chevron-down</v-icon>
          </v-btn>
          <v-divider vertical></v-divider>
        </div>
        <v-btn
          v-for="item in items"
          :key="item.title"
          :to="item.link"
          text
          :color="item.color ?? null"
        >
          <v-badge
            v-if="item.link == 'cart'"
            :content="cartQty"
            :value="cartQty"
            color="green"
            overlap
          >
            <v-icon small left>{{ item.icon }}</v-icon>
          </v-badge>
          <v-badge
            v-else-if="item.link == 'wish-list'"
            :content="wishListQty"
            :value="wishListQty"
            color="green"
            overlap
          >
            <v-icon small left color="red darken-4">{{ item.icon }}</v-icon>
          </v-badge>
          <v-icon v-else small left>{{ item.icon }}</v-icon>
          {{ item.title }}
        </v-btn>
        <v-btn
          @click="changeContext"
          text
          color="red"
          v-if="isChangeContextEnabled"
        >
          <v-icon small left>mdi-logout</v-icon>
          Sair
        </v-btn>
      </v-toolbar-items>
    </v-app-bar>

    <v-navigation-drawer
      v-if="drawer"
      v-model="drawer"
      absolute
      temporary
      right
    >
      <v-list dense>
        <v-list-item
          v-for="item in items"
          :key="item.title"
          :to="item.link"
          link
        >
          <v-list-item-icon>
            <div v-if="item.link == 'cart'">
              <v-badge
                :content="cartQty"
                :value="cartQty"
                color="green"
                overlap
              >
                <v-icon small>{{ item.icon }}</v-icon>
              </v-badge>
            </div>
            <div v-else-if="item.link == 'wish-list'">
              <v-badge
                :content="wishListQty"
                :value="wishListQty"
                color="green"
                overlap
              >
                <v-icon small color="red"> {{ item.icon }} </v-icon>
              </v-badge>
            </div>
            <v-icon v-else small>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-btn
          @click="changeContext"
          text
          color="red"
          v-if="isChangeContextEnabled"
        >
          <v-icon small left>mdi-logout</v-icon>
          Sair
        </v-btn>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import cInputCep from '@/components/button/BaseInputCEP.vue'
import { mapState, mapGetters, mapActions } from 'vuex'
import { regionMixin } from '@/mixins/region/RegionMixin'

export default {
  components: {
    cInputCep,
  },
  mixins: [regionMixin],
  data: () => ({
    loadingButton: false,
    form: null,
    drawer: false,
    show: false,
    showFormCEP: false,
    items: [
      { title: 'Inicio', link: '/', icon: 'fa-home' },
      { title: 'Loja', link: 'store', icon: 'fa-shopping-basket' },
      { title: 'Favoritos', link: 'wish-list', icon: 'fa-heart' },
      { title: 'Carrinho', link: 'cart', icon: 'fa-shopping-cart' },
    ],
  }),
  computed: {
    ...mapState('productModule', ['wishList']),
    ...mapGetters('productModule', ['cart']),
    ...mapGetters('companyListModule', ['companyList']),

    cartQty() {
      return this.cart.reduce((sum, item) => {
        return (sum += item.quantity)
      }, 0)
    },

    wishListQty() {
      return this.wishList.length
    },

    logoPath() {
      return process.env.VUE_APP_LOGOEMPRESA
    },

    isChangeContextEnabled() {
      const isChangeContext = process.env.VUE_APP_CHANGE_VIEWCONTEXT ?? 'false'
      return (
        isChangeContext == 'true' &&
        this.$store.state.viewContext == 'companyList'
      )
    },
  },
  methods: {
    ...mapActions('regionModule', ['setRegion', 'getRegionTax']),
    ...mapActions('productModule', ['getProducts']),
    ...mapActions('companyListModule', ['clearCompanyList']),

    openCepDialog() {
      this.form = this.region ? this.region : Object.assign({}, this.frmAddress)
      this.showFormCEP = !this.showFormCEP
    },

    closeCepDialog() {
      this.form = null
      this.showFormCEP = false
    },

    async consultaValorFrete() {
      try {
        if (this.cmpRegion.cep.value.length <= 0) return

        this.loadingButton = true
        const payload = {
          city: this.region.cidade.value,
          neighbourhood: this.region.bairro.value,
        }

        await this.getRegionTax(payload)
        this.closeCepDialog()
      } catch (error) {
        this.$store.dispatch('updateSnackbar', {
          variant: 'error',
          message: error,
          show: true,
        })
      } finally {
        this.loadingButton = false
      }
    },

    openAccount() {
      this.showFormAccount = !this.showFormAccount
    },

    async toHome() {
      if (this.$route.name != 'home') this.$router.push({ name: 'home' })
    },
    async changeContext() {
      if (
        await this.$root.$confirm(
          'Confirmar saída deste ambiente',
          'Deseja realmente sair deste ambiente? \r\nVocê poderá retornar aqui somente com seu link de acesso a loja',
          { color: 'red' }
        )
      ) {
        this.$router.push({ name: 'changeContext' })
      }
    },
  },
}
</script>

<style>
.my-custom-dialog {
  position: absolute;
  left: 0;
  top: 10%;
}

.v-btn {
  text-transform: none;
  font-size: 0.8em !important;
}
</style>
